<template>
    <div class="mainBody">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px" style="width: 80%">
            <el-form-item label="接口类型：" prop="action_type">
                <el-select v-model="model.action_type" placeholder="请选择" style="width: 300px">
                    <el-option label="获取TOKEN" value="1"></el-option>
                    <el-option label="获取车辆列表" value="2"></el-option>
                    <el-option label="获取车辆简易信息" value="3"></el-option>
                    <el-option label="获取车辆详细信息(接口)" value="4"></el-option>
                    <el-option label="获取车辆详细信息(数据库)" value="5"></el-option>
                    <el-option label="唤醒车辆" value="6"></el-option>
                    <el-option label="获取交付订单" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="model.email" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <el-input v-model="model.car_id" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item >
                <el-button type="primary" @click="getTslInfo" size="medium">获取信息</el-button>
            </el-form-item>
            <el-form-item label="结果：">
                <el-input type="textarea" v-model="result" rows="6"></el-input>
            </el-form-item>
        </el-form>
        
    </div>
</template>

<script>
import { toolsAction } from '@/api/carreport'
export default {
    name: 'carInfoTools',
    data() {
        return {
            model: {
                action_type: '1',
                email: '',
                car_id: '',
            },
            result: '',
            rules: {
                email: [
                    {required: true, message: '邮箱不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        getTslInfo(){
            this.result = ''
            toolsAction(this.model.action_type, this.model.email, this.model.car_id).then(res=>{
                console.log(res)
                if(res.code == 1){
                    this.result = res.data
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>